<template>
  <div class="image-slider" >
      <div class="swiper free-prouct-sw" ref="swiperRef">
          <div class="swiper-wrapper" :class="{ 'swiper-grid': !isMobile }">
              
            <div :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box ">
                <video  @contextmenu.prevent="" controlsList="nodownload"  controls width="400" height="400" autoplay loop muted playsinline>
                      <source src="https://assets.friendlydiamonds.com/fdl/products/shop/necklace/video/AFDN1001_w.mp4?64cb7703551a9" type="video/mp4" />
                      Your browser does not support the video tag.
                </video>
            </div>
              <div :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box p-md-1">
                  <img  src="https://assets.friendlydiamonds.com/fdl/products/shop/necklace/w/imaged/AFDN1001/AFDN1001_wf.jpg?64cb7703550f2" alt="solitaire pendant small front image">
              </div>

              <div :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box p-md-1">
                <img  src="https://assets.friendlydiamonds.com/fdl/products/shop/necklace/w/imaged/AFDN1001/AFDN1001_wl.jpg?64cb77035514a" alt="solitaire pendant small side image">
              </div>
              <div :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box p-md-1">
                <img  src="https://assets.friendlydiamonds.com/fdl/products/shop/necklace/w/imaged/AFDN1001/AFDN1001_wr.jpg?64cb770355185" alt="solitaire pendant small another side image">
              </div>
             
              <!-- <div :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box p-md-1">
                <img  class="p-2" src="~/assets/360_icon.png" alt="solitaire pendant video view image">
              </div> -->

              <!-- <div v-for="(image, key) in images" :key="key" :class="{ 'swiper-slide': isMobile }" class="swiper-slide-box p-md-1">

                  <video v-if="image?.includes('.mp4')" @contextmenu.prevent="" controlsList="nodownload" ref="video" controls width="400" height="400" autoplay loop muted playsinline>
                      <source :src="image" type="video/mp4" />
                      Your browser does not support the video tag.
                  </video>

                  <iframe v-else-if="image?.includes('.html') || image.includes('loupe360.com')" :src="image" style="width: 100%; height:300px;" class="grid-iframe "></iframe>

                  <img v-else :src="image" :alt="key">

              </div> -->

          </div>

          <div class="free-prouct-swiper-pagination swiper-pagination"></div>

      </div>
  </div>

</template>
<script setup>
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

const { isMobile : isMobile } = useDevice()
const swiperRef = ref(null)

onMounted(() => {
  if (isMobile) {
      new Swiper('.free-prouct-sw', {
          spaceBetween: 20,
          modules:[Pagination],
          pagination: {
              el: '.free-prouct-swiper-pagination',
              clickable: true,
          },
      })
  }
})



onBeforeUnmount( () =>  {

  if (swiperRef?.value?.swiper?.destroy instanceof Function) {
      swiperRef?.value?.swiper?.destroy(true, true);
      console.log("Swiper instance destroyed successfully.");
  }
})


</script>

<style scoped>
img,
video {
  border: 1px solid #f5f5f5;
  border-radius: 8px;
}

video {
  width: 100%;
  height: auto;
}

iframe {
  border: 1px solid #f5f5f5;
  border-radius: 8px;
}

.swiper-grid {
  display: flex;
  flex-wrap: wrap;
}

.swiper-slide-box {
  width: 50%;   
  height: 100%;
}

.swiper-slide-box:first-child {
  width: 100%;
}

img{
  max-width:100%;
  height: auto;
}

img, video {
  border: 1px solid #f5f5f5;
  border-radius: 8px;
}


iframe{
  border: 1px solid #f5f5f5;
  border-radius: 8px;
}


.image-slider {
  width: 100%;
  height: 100%;
}


:global(.image-slider .swiper-slide) {
  height: auto !important;
}

/* swiper pagination: mobile */
:global(.image-slider .swiper-pagination) {
  position: relative;
}

:global(.image-slider .swiper-pagination-bullet) {
  background: #c4c4c4 !important;
  opacity: 1 !important;
}

:global(.image-slider .swiper-pagination-bullet-active) {
  background: #606060 !important;
}
</style>